module.exports = __webpack_public_path__ + "43e9cd2771a7ca439bec8161c563e57a.png";